import { render, staticRenderFns } from "./logisticsCheck.vue?vue&type=template&id=00c1aeae&scoped=true&"
import script from "./logisticsCheck.vue?vue&type=script&lang=js&"
export * from "./logisticsCheck.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCheck.vue?vue&type=style&index=0&id=00c1aeae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1aeae",
  null
  
)

export default component.exports